(() => {
  const IMG = window.SNUG_ASSET_BASE || "assets/";
  const LOC = window.FF_LANG === "en" ? "en-GB" : "de-DE";
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const euro = (n) => n.toFixed(2).replace(".", ",") + " €";
  // 2er-Set: zwei beliebige Tiere. Der Abzug kommt aus dem Shop-Metafeld flausch.set_rabatt (passend zum automatischen Rabatt in Shopify), 0 = kein Abzug
  const SET_OFF = typeof window.SNUG_SET_OFF === "number" ? window.SNUG_SET_OFF : 0;
  // Versand: 4,90 €, ab 40 € Bestellwert kostenlos (so auch in Shopify unter Versand eingestellt)
  const FREE_FROM = 40, SHIP = 4.9;
  const shipFor = (sub) => (sub <= 0 || sub >= FREE_FROM ? 0 : SHIP);
  // Aktion (z. B. Winterfreude −10 %): Prozent und Enddatum aus den Shop-Metafeldern flausch.aktion_pct / flausch.aktion_ende.
  // Shopify kombiniert sie nicht mit dem 2er-Set, sondern nimmt den höheren Rabatt. Genau so rechnet die Seite auch.
  const PCT = (() => { const p = +window.SNUG_PCT || 0, end = Date.parse(window.SNUG_PCT_END || ""); return p > 0 && !(end && Date.now() > end) ? p : 0; })();
  const cents = (n) => Math.round(n * 100) / 100;
  const pctOff = (sum) => (PCT ? cents(sum * PCT / 100) : 0);
  const sale = (n) => cents(n - pctOff(n));
  const setWins = (sum, pieces) => pieces >= 2 && SET_OFF > 0 && SET_OFF >= pctOff(sum);
  const offFor = (sum, pieces) => (setWins(sum, pieces) ? SET_OFF : pctOff(sum));
  const offLabel = (sum, pieces) => (setWins(sum, pieces) ? "2er-Set Rabatt" : "Winterfreude −" + PCT + " %");
  const priceHTML = (n) => (PCT ? '<s class="was">' + n.toFixed(2).replace(".", ",") + "</s> " : "") + euro(sale(n));

  // ============================================================
  // SORTIMENT – Preise pro Tier inkl. Versand
  // handle = Shopify-Produkt, label = Wert der Option "Farbe"
  // ============================================================
  const ANIMALS = {
    kuh: {
      handle: "hochlandkuh", nick: "Klara", name: "Hochlandkuh", two: "Hochlandkühe", size: "40\u00a0cm", price: 35.9,
      colors: {
        rosa: { label: "Rosa", img: "ff-kuh-rosa.webp", dot: "#e7b8b2", alt: "Rosa Hochlandkuh aus Plüsch mit flauschigem Pony, sitzend" },
        weiss: { label: "Weiß", img: "ff-kuh-weiss.webp", dot: "#f7f3ee", alt: "Weiße Hochlandkuh aus Plüsch mit dunkelbraunen Hörnern und Pfoten" },
        braun: { label: "Braun", img: "ff-kuh-braun.webp", dot: "#c79d77", alt: "Hellbraune Hochlandkuh aus Plüsch mit braunen Hörnern und Pfoten" }
      }
    },
    panda: {
      handle: "panda", nick: "Paul", name: "Panda", two: "Pandas", size: "45\u00a0cm", price: 37.9,
      colors: {
        schwarz: { label: "Schwarz-Weiß", img: "ff-panda-schwarz.webp", dot: "#222222", alt: "Schwarz-weißer Panda aus Plüsch mit rosa Bäckchen" },
        braun: { label: "Braun-Creme", img: "ff-panda-braun.webp", dot: "#a8724a", alt: "Brauner Panda aus Plüsch mit cremefarbenem Gesicht und Bauch" }
      }
    },
    "roter-panda": {
      handle: "roter-panda", nick: "Ruby", name: "Roter Fuchs", two: "Rote Füchse", size: "55\u00a0cm", price: 44.9,
      colors: {
        rotbraun: { label: "Rotbraun", img: "ff-roter-panda.webp", dot: "#b9622d", alt: "Roter Fuchs aus Plüsch mit rotbraunem Fell und weißen Ohren" }
      }
    },
    hase: {
      handle: "hase", nick: "Hanni", name: "Hase", two: "Hasen", size: "45\u00a0cm", price: 37.9,
      colors: {
        creme: { label: "Creme", img: "ff-hase.webp", dot: "#f1e5d3", alt: "Cremefarbener Hase aus Plüsch mit langen flauschigen Ohren und rosa Pfoten" }
      }
    }
  };
  const KEYS = Object.keys(ANIMALS);
  // Preise aus Shopify übernehmen (Variante „Einzeln“), damit Seite und Kasse immer übereinstimmen
  KEYS.forEach((k) => {
    const p = (window.SNUG_PRODUCTS || {})[ANIMALS[k].handle];
    const v = p && p.variants && p.variants.find((x) => x.options.includes("Einzeln"));
    if (v) ANIMALS[k].price = v.price / 100;
  });
  $$("[data-price-of]").forEach((e) => { if (ANIMALS[e.dataset.priceOf]) e.innerHTML = priceHTML(ANIMALS[e.dataset.priceOf].price); });
  const QTY_NAME = "Einzeln";
  const firstColor = (k) => Object.keys(ANIMALS[k].colors)[0];
  const title = (k) => ANIMALS[k].nick + " (" + ANIMALS[k].name + ")";
  const otherColor = (k, c) => Object.keys(ANIMALS[k].colors).find((x) => x !== c);
  // Lieferdatum: Werktage ab heute, ohne Wochenenden
  const addWorkdays = (d, n) => { const x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() % 6) n--; } return x; };
  const shortDate = (d) => d.toLocaleDateString(LOC, { weekday: "short", day: "numeric", month: "short" });
  const state = { animal: "kuh", color: "rosa", qty: 1, second: { animal: "kuh", color: "weiss" }, shown: 39.9 };

  // ---------- Toast ----------
  const toastEl = $("[data-toast]"); let tt;
  // Großansicht (Lightbox) für das gewählte Tier
  const lightbox = (src, alt, cap) => {
    let d = $("[data-lb]");
    if (!d) {
      d = document.createElement("dialog"); d.className = "lb"; d.setAttribute("data-lb", "");
      d.innerHTML = '<button type="button" class="lb-x" aria-label="Schließen">×</button><img alt=""><p class="lb-cap"></p>';
      document.body.appendChild(d);
      $(".lb-x", d).addEventListener("click", () => d.close());
      d.addEventListener("click", (e) => { if (e.target === d || e.target.tagName === "IMG") d.close(); });
    }
    $("img", d).src = src; $("img", d).alt = alt; $(".lb-cap", d).textContent = cap;
    d.showModal ? d.showModal() : d.setAttribute("open", "");
  };
  const toast = (m) => { if (!toastEl) return; toastEl.textContent = m; toastEl.classList.add("on"); clearTimeout(tt); tt = setTimeout(() => toastEl.classList.remove("on"), 2400); };

  // ============================================================
  // KAUFBEREICH (nur Start- und Produktseite)
  // ============================================================
  const hero = $("#kaufen");
  const slides = $("[data-slides]");
  const slideOf = (k) => $('[data-slide="' + k + '"]', slides);
  const currentImg = () => (slides ? $("[data-slide-img]", slideOf(state.animal)) : null);

  // Foto im Karussell auf die gewählte Farbe stellen (weiches Überblenden)
  const showPic = () => {
    const a = ANIMALS[state.animal], c = a.colors[state.color], img = currentImg();
    if (!img) return;
    if (img.getAttribute("src") === IMG + c.img) return;
    const box = img.parentElement;
    const swap = () => { img.src = IMG + c.img; img.alt = c.alt; };
    if (reduce) return swap();
    box.classList.add("swap");
    setTimeout(() => { swap(); const done = () => box.classList.remove("swap"); img.complete ? done() : (img.onload = done); }, 200);
  };

  // Preis zählt weich zum neuen Wert
  const setTotals = (to) => {
    const els = $$("[data-total]"), from = state.shown;
    state.shown = to;
    if (reduce || from === to) { els.forEach((e) => (e.textContent = euro(to))); return; }
    const t0 = performance.now(), dur = 420;
    const step = (t) => {
      const k = Math.min(1, (t - t0) / dur), v = from + (to - from) * (1 - Math.pow(1 - k, 3));
      els.forEach((e) => (e.textContent = euro(v)));
      if (k < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
    const big = $("[data-main-total]");
    if (big) { big.classList.remove("bump"); void big.offsetWidth; big.classList.add("bump"); }
  };

  const swBox = $("[data-swatches]");
  const buildSwatches = () => {
    if (!swBox) return;
    const a = ANIMALS[state.animal];
    swBox.innerHTML = "";
    Object.entries(a.colors).forEach(([k, c]) => {
      const b = document.createElement("button");
      b.type = "button"; b.className = "chip"; b.dataset.color = k;
      b.innerHTML = "<i aria-hidden=\"true\"></i><span></span>"; $("i", b).style.background = c.dot; $("span", b).textContent = c.label;
      b.addEventListener("click", () => { state.color = k; render(); });
      swBox.appendChild(b);
    });
  };

  const setText = (sel, txt) => $$(sel).forEach((e) => (e.textContent = txt));

  // Zweites Tier fürs Set: Mini-Kacheln und Farbpunkte
  const secBox = $("[data-second]");
  const buildSecond = () => {
    if (!secBox) return;
    const grid = $("[data-second-animals]", secBox), cols = $("[data-second-colors]", secBox);
    if (!grid.children.length) KEYS.forEach((k) => {
      const b = document.createElement("button"); b.type = "button"; b.className = "mini"; b.dataset.sec = k;
      b.innerHTML = '<span class="photo"><img alt="" width="160" height="160" loading="lazy"></span><b></b>';
      $("img", b).src = IMG + ANIMALS[k].colors[firstColor(k)].img; $("b", b).textContent = ANIMALS[k].nick;
      b.addEventListener("click", () => { state.second = { animal: k, color: firstColor(k) }; render(); });
      grid.appendChild(b);
    });
    const sa = ANIMALS[state.second.animal];
    $$("[data-sec]", grid).forEach((b) => b.setAttribute("aria-pressed", b.dataset.sec === state.second.animal));
    $$("[data-sec] img", grid).forEach((img) => { const k = img.closest("[data-sec]").dataset.sec; if (k === state.second.animal) img.src = IMG + sa.colors[state.second.color].img; });
    cols.innerHTML = "";
    Object.entries(sa.colors).forEach(([k, c]) => {
      const b = document.createElement("button"); b.type = "button"; b.className = "chip chip-s"; b.dataset.color = k;
      b.innerHTML = "<i aria-hidden=\"true\"></i><span></span>"; $("i", b).style.background = c.dot; $("span", b).textContent = c.label;
      b.setAttribute("aria-pressed", k === state.second.color);
      b.addEventListener("click", () => { state.second.color = k; render(); });
      cols.appendChild(b);
    });
  };
  // Standard fürs zweite Tier: gleiches Tier in anderer Farbe, sonst das nächste Tier
  const suggestSecond = () => {
    const oc = otherColor(state.animal, state.color);
    state.second = oc ? { animal: state.animal, color: oc } : { animal: KEYS[(KEYS.indexOf(state.animal) + 1) % KEYS.length], color: firstColor(KEYS[(KEYS.indexOf(state.animal) + 1) % KEYS.length]) };
  };

  const render = () => {
    if (!hero) return;
    const a = ANIMALS[state.animal], c = a.colors[state.color];
    const set = state.qty === 2, b2 = ANIMALS[state.second.animal], c2 = b2.colors[state.second.color];
    const full = a.price + (set ? b2.price : 0), off = offFor(full, set ? 2 : 1), price = cents(full - off);
    showPic();
    // Gewählte Farbe überall sichtbar machen: Kachel, Vorschau neben dem Preis, Leiste unten
    const colorChanged = state.lastPick && state.lastPick !== state.animal + "/" + state.color;
    state.lastPick = state.animal + "/" + state.color;
    $$("[data-animal]").forEach((b) => {
      const k = b.dataset.animal, im = $("img", b);
      if (im && ANIMALS[k]) {
        const want = IMG + (k === state.animal ? c.img : ANIMALS[k].colors[firstColor(k)].img);
        if (im.getAttribute("src") !== want) im.src = want;
      }
      if (colorChanged && k === state.animal && !reduce) { b.classList.remove("pop"); void b.offsetWidth; b.classList.add("pop"); }
    });
    $$("[data-q-img='1']").forEach((i) => { if (i.getAttribute("src") !== IMG + c.img) i.src = IMG + c.img; });
    $$("[data-q-img='2']").forEach((i) => { const w = IMG + c2.img; if (i.getAttribute("src") !== w) i.src = w; });
    const bigImg = $("[data-big-img]");
    if (bigImg && bigImg.getAttribute("src") !== IMG + c.img) {
      const bp = bigImg.parentElement;
      if (reduce) bigImg.src = IMG + c.img;
      else { bp.classList.add("swap"); setTimeout(() => { bigImg.src = IMG + c.img; bp.classList.remove("swap"); }, 170); }
    }
    if (bigImg) { bigImg.alt = a.nick + " in " + c.label; setText("[data-big-name]", a.nick); setText("[data-big-color]", c.label); }
    const sp = $("[data-sum-pic]");
    if (sp) {
      const im = $("img", sp), want = IMG + c.img;
      if (im.getAttribute("src") !== want) {
        if (reduce) im.src = want;
        else { sp.classList.add("swap"); setTimeout(() => { im.src = want; sp.classList.remove("swap"); sp.classList.remove("pop"); void sp.offsetWidth; sp.classList.add("pop"); }, 160); }
      }
      im.alt = a.nick + " in " + c.label;
      setText("[data-sum-tag]", c.label);
    }
    $$("[data-animal]").forEach((b) => {
      const on = b.dataset.animal === state.animal;
      b.setAttribute("aria-pressed", on);
      const pick = $(".pick", b); if (pick) pick.textContent = on ? "Ausgewählt" : "Wählen";
    });
    $$("[data-dot]").forEach((d) => d.setAttribute("aria-current", d.dataset.dot === state.animal));
    $$(".chip", swBox).forEach((b) => b.setAttribute("aria-pressed", b.dataset.color === state.color));
    $$("[data-qty]").forEach((b) => b.setAttribute("aria-pressed", +b.dataset.qty === state.qty));
    if (secBox) { secBox.hidden = !set; if (set) buildSecond(); }
    setText("[data-tier-label]", set ? "Erstes Tier" : "Tier");
    hero.classList.toggle("is-set", set);
    setText("[data-animalname]", a.name);
    setText("[data-nick]", a.nick);
    setText("[data-size]", a.size);
    setText("[data-inbox]", set ? "2 Plüschtiere" : "1 Plüschtier");
    const nColors = Object.keys(a.colors).length;
    setText("[data-colorname]", c.label);
    setText("[data-colorcount]", nColors > 1 ? nColors + " Farben" : "nur in " + c.label);
    const bp1 = $("[data-bprice='1']"); if (bp1) bp1.innerHTML = priceHTML(a.price);
    const was = $("[data-was]"); if (was) { was.hidden = !off; was.textContent = euro(full); }
    setText("[data-bprice='2']", SET_OFF ? "−" + SET_OFF + " €" : euro(a.price + b2.price));
    const names = set ? a.nick + " und " + b2.nick : a.nick;
    setText("[data-per]", set ? a.nick + " (" + c.label + ") und " + b2.nick + " (" + c2.label + ")" : a.nick + ", " + a.name + " in " + c.label);
    const rcBox = $(".receipt", hero); if (rcBox) rcBox.hidden = false;
    const ship = shipFor(price);
    setText("[data-dtotal]", euro(price + ship));
    setText("[data-rc-ship]", ship ? euro(ship) : "kostenlos");
    setText("[data-q1-ship]", sale(a.price) >= FREE_FROM ? "Versand kostenlos" : "zzgl. Versand");
    $$("[data-free-ship]").forEach((e) => { e.classList.toggle("is-free", !ship); e.innerHTML = ship ? "zzgl. " + euro(SHIP) + " Versand <small>· ab 40 € kostenlos</small>" : "inkl. <b>kostenlosem Versand</b>"; });
    setText("[data-barname]", set ? a.nick + " + " + b2.nick : a.nick + " · " + c.label);
    // Kassenbon: jedes Tier einzeln, Set-Rabatt, Versand 0 €, Endbetrag
    $$("[data-rc-item]").forEach((e) => { e.innerHTML = "<b></b><small></small>"; $("b", e).textContent = a.nick + " · " + c.label; $("small", e).textContent = a.name + " · " + a.size; });
    $$("[data-rc-img]").forEach((i) => { if (i.getAttribute("src") !== IMG + c.img) i.src = IMG + c.img; });
    $$("[data-rc-img2]").forEach((i) => { if (i.getAttribute("src") !== IMG + c2.img) i.src = IMG + c2.img; });
    setText("[data-rc-price]", euro(a.price));
    const r2 = $("[data-rc-row2]"), rs = $("[data-rc-set]");
    $$("[data-bar-img2]").forEach((i) => { i.hidden = !set; i.parentElement.hidden = !set; if (set) i.src = IMG + c2.img; });
    setText("[data-bar-save]", off ? "−" + euro(off) + " gespart" : price >= FREE_FROM ? "Versand kostenlos" : "zzgl. " + euro(SHIP) + " Versand");
    if (r2) { r2.hidden = !set; const it2 = $("[data-rc-item2]"); it2.innerHTML = "<b></b><small></small>"; $("b", it2).textContent = b2.nick + " · " + c2.label; $("small", it2).textContent = b2.name + " · " + b2.size; $("[data-rc-price2]").textContent = euro(b2.price); }
    if (rs) { rs.hidden = !off; $("b", rs).textContent = "−" + euro(off); setText("[data-rc-setlabel]", setWins(full, set ? 2 : 1) ? "2er-Set" : "Winterfreude −" + PCT + " %"); }
    const note = $("[data-rc-note]");
    if (note) {
      note.hidden = false;
      note.textContent = set ? "Pro Tier nur " + euro(Math.ceil(price / 2 * 100) / 100) + ", Versand kostenlos." : price < FREE_FROM ? "Mit einem zweiten Tier ist der Versand kostenlos" + (SET_OFF ? " und du sparst " + SET_OFF + " €." : ".") : SET_OFF ? "Mit einem zweiten Tier sparst du " + SET_OFF + " €." : "";
      note.hidden = !note.textContent;
    }
    const eta = $("[data-eta]");
    if (eta) {
      const now = new Date();
      eta.innerHTML = "Heute bestellt, " + (set ? "sind " : "ist ") + names + " voraussichtlich zwischen <b></b> und <b></b> bei dir.";
      $$("b", eta)[0].textContent = shortDate(addWorkdays(now, 5)); $$("b", eta)[1].textContent = shortDate(addWorkdays(now, 10));
    }
    $$("[data-bar-img]").forEach((i) => { i.src = IMG + c.img; });
    setTotals(price);
  };

  // ---------- Karussell: Wischen wählt das Tier, Wählen scrollt das Karussell ----------
  let quietUntil = 0;
  const goToSlide = (k, smooth = true) => {
    if (!slides) return;
    const i = KEYS.indexOf(k);
    quietUntil = performance.now() + 700;
    slides.scrollTo({ left: i * slides.clientWidth, behavior: smooth && !reduce ? "smooth" : "auto" });
  };
  const pickAnimal = (k, fromSwipe = false) => {
    if (!ANIMALS[k]) return;
    if (k !== state.animal) { state.animal = k; state.color = firstColor(k); buildSwatches(); if (state.qty === 1) suggestSecond(); }
    if (!fromSwipe) goToSlide(k);
    render();
  };
  if (slides) {
    let st;
    slides.addEventListener("scroll", () => {
      clearTimeout(st);
      st = setTimeout(() => {
        if (performance.now() < quietUntil) return;
        const k = KEYS[Math.round(slides.scrollLeft / slides.clientWidth)];
        if (k && k !== state.animal) pickAnimal(k, true);
      }, 90);
    }, { passive: true });
    addEventListener("resize", () => goToSlide(state.animal, false));
    $$("[data-dot]").forEach((d) => d.addEventListener("click", () => pickAnimal(d.dataset.dot)));
    $$("[data-step]").forEach((b) => b.addEventListener("click", () => {
      const i = (KEYS.indexOf(state.animal) + +b.dataset.step + KEYS.length) % KEYS.length;
      pickAnimal(KEYS[i]);
    }));
    slides.addEventListener("keydown", (e) => {
      if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
      e.preventDefault();
      const i = (KEYS.indexOf(state.animal) + (e.key === "ArrowRight" ? 1 : -1) + KEYS.length) % KEYS.length;
      pickAnimal(KEYS[i]);
    });
    // Tier antippen: es wackelt kurz, wie beim Schütteln
    $$("[data-slide-img]").forEach((img) => img.addEventListener("click", () => {
      if (reduce || !img.animate) return;
      img.animate([{ transform: "rotate(0)" }, { transform: "rotate(-4deg) translateY(-8px)" }, { transform: "rotate(4deg)" }, { transform: "rotate(-3deg) translateY(-5px)" }, { transform: "rotate(0)" }], { duration: 600, easing: "ease-in-out" });
    }));
  }

  if (hero) {
    const openPick = () => { const a = ANIMALS[state.animal], c = a.colors[state.color]; lightbox(IMG + c.img, a.nick + " in " + c.label, a.nick + " · " + a.name + " in " + c.label + " · " + a.size); };
    const bigPick = $("[data-big-pick]"); if (bigPick) bigPick.addEventListener("click", openPick);
    $$("[data-animal]").forEach((b) => b.addEventListener("click", () => {
      // Leiste unten: ein Tippen auf das schon gewählte Tier zeigt es groß
      if (b.classList.contains("bp") && b.dataset.animal === state.animal) { openPick(); return; }
      pickAnimal(b.dataset.animal);
      // Karte weiter unten: zurück nach oben zum Kaufen
      if (b.classList.contains("gcard")) {
        toast(ANIMALS[state.animal].nick + " ist ausgewählt");
        hero.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
      }
    }));
    $$("[data-qty]").forEach((b) => b.addEventListener("click", () => {
      const toSet = state.qty === 1 && +b.dataset.qty === 2;
      if (toSet) suggestSecond();
      state.qty = +b.dataset.qty; render();
      // Das zweite Tier sichtbar machen, damit klar ist, was jetzt passiert
      if (toSet && secBox) setTimeout(() => secBox.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "nearest" }), 60);
    }));
  }

  // ============================================================
  // WARENKORB (auf allen Seiten; lokal in der Vorschau, in Shopify über /cart.js)
  // ============================================================
  const SHOP = !!window.SNUG_SHOPIFY;
  const PRODUCTS = window.SNUG_PRODUCTS || {};
  const drawer = $("[data-drawer]"), scrim = $("[data-scrim]"), badge = $("[data-count-badge]");
  let lastFocus = null, local = [], shopRows = [];
  const openCart = () => {
    lastFocus = document.activeElement;
    scrim.hidden = false; requestAnimationFrame(() => { scrim.classList.add("on"); drawer.classList.add("on"); });
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("drawer-open"); document.documentElement.style.overflow = "hidden";
    setTimeout(() => $("[data-close-cart]").focus(), 60);
  };
  const closeCart = () => {
    scrim.classList.remove("on"); drawer.classList.remove("on"); drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("drawer-open"); document.documentElement.style.overflow = "";
    setTimeout(() => (scrim.hidden = true), 350);
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  };
  const api = (url, body) => fetch(url, body ? { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) } : { headers: { Accept: "application/json" } }).then((r) => { if (!r.ok) throw new Error(r.status); return r.json(); });
  const keyOfHandle = (h) => KEYS.find((k) => ANIMALS[k].handle === h);
  const colorOfLabel = (k, l) => Object.keys(ANIMALS[k].colors).find((c) => ANIMALS[k].colors[c].label === l) || firstColor(k);
  const findVariant = (k, col) => {
    const p = PRODUCTS[ANIMALS[k].handle]; if (!p || !p.variants) return null;
    const c = ANIMALS[k].colors[col].label;
    return p.variants.find((v) => v.options.includes(c) && v.options.includes(QTY_NAME)) || null;
  };
  // Zeilen in einheitlicher Form: { key, color, qty, n, price, id }
  const rows = () => SHOP ? shopRows : local.map((x) => ({ ...x, price: ANIMALS[x.key].price * x.n }));
  const loadCart = () => api("/cart.js").then((c) => {
    shopRows = c.items.filter((it) => keyOfHandle(it.handle)).map((it) => {
      const key = keyOfHandle(it.handle);
      const opts = it.options_with_values || [];
      const col = (opts.find((o) => o.name === "Farbe") || {}).value;
      const q = (opts.find((o) => o.name === "Anzahl") || {}).value === "Zu zweit" ? 2 : 1;
      return { key, color: colorOfLabel(key, col), qty: q, n: it.quantity, price: it.original_line_price / 100, id: it.key };
    });
    renderCart();
  }).catch(() => {});
  const change = async (r, delta) => {
    if (r.n + delta <= 0) {
      const ok = window.snugConfirm ? await window.snugConfirm("Aus dem Warenkorb entfernen?", title(r.key) + " wird entfernt.", "Entfernen", "Behalten") : true;
      if (!ok) return;
    }
    if (SHOP) { api("/cart/change.js", { id: r.id, quantity: r.n + delta }).then(loadCart).catch(() => toast("Das hat nicht geklappt. Bitte noch einmal versuchen.")); return; }
    const x = local.find((c) => c.key === r.key && c.color === r.color);
    x.n += delta; if (x.n <= 0) local = local.filter((c) => c !== x); renderCart();
  };
  const renderCart = () => {
    if (!drawer) return;
    const box = $("[data-items]"); box.innerHTML = "";
    let sum = 0, pieces = 0;
    rows().forEach((r) => {
      const a = ANIMALS[r.key], c = a.colors[r.color];
      sum += r.price; pieces += r.n * r.qty;
      const row = document.createElement("div"); row.className = "dr-item";
      row.innerHTML = '<div class="dr-img"><img src="' + IMG + c.img + '" alt="" width="144" height="144"></div>' +
        '<div class="dr-info"><b></b><span></span><div class="dr-qty"><button type="button" aria-label="Eins weniger">−</button><output class="num"></output><button type="button" aria-label="Eins mehr">+</button></div></div>' +
        '<strong class="num"></strong>';
      $("b", row).textContent = (r.qty === 2 ? "2× " : "") + title(r.key);
      $("span", row).textContent = c.label + " · " + a.size;
      $("output", row).textContent = r.n;
      $("strong", row).textContent = euro(r.price);
      const [minus, plus] = $$("button", row);
      minus.addEventListener("click", () => change(r, -1));
      plus.addEventListener("click", () => change(r, 1));
      box.appendChild(row);
    });
    const off = offFor(sum, pieces), net = cents(sum - off), ship = shipFor(net);
    $("[data-cart-sub]").textContent = euro(sum);
    const setRow = $("[data-cart-set]");
    if (setRow) { setRow.hidden = !off; $("[data-cart-setoff]").textContent = "−" + euro(off); const sl = $("[data-cart-setlabel]"); if (sl) sl.textContent = offLabel(sum, pieces); }
    $("[data-cart-ship]").textContent = sum ? (ship ? euro(ship) : "kostenlos") : "–";
    $("[data-cart-ship]").classList.toggle("is-free", sum > 0 && !ship);
    $("[data-cart-total]").textContent = euro(net + ship);
    const cnt = $("[data-dr-count]"); if (cnt) cnt.textContent = pieces ? "(" + pieces + ")" : "";
    // Fortschritt bis zum kostenlosen Versand
    const ft = $("[data-free-text]"), fb = $("[data-free-bar]"), fr = $("[data-free]");
    if (ft && fb) {
      const left = cents(Math.max(0, FREE_FROM - net));
      fb.style.setProperty("--p", Math.min(1, net / FREE_FROM));
      fr.style.setProperty("--p-l", Math.min(100, net / FREE_FROM * 100));
      fr.classList.toggle("is-done", sum > 0 && net >= FREE_FROM);
      ft.innerHTML = !sum ? "Ab <b>40 €</b> ist der Versand kostenlos." : left > 0 ? "Noch <b class=\"num\">" + euro(left) + "</b> bis zum kostenlosen Versand. Ein zweites Tier reicht" + (SET_OFF ? " und spart " + SET_OFF + " €!" : "!") : "<b>Geschafft!</b> Dein Versand ist kostenlos ♥";
    }
    // Vorschläge: Tiere, die noch nicht im Warenkorb sind
    const up = $("[data-upsell]"), upRow = $("[data-upsell-row]");
    if (up && upRow) {
      const inCart = rows().map((r) => r.key);
      const pick = KEYS.filter((k) => !inCart.includes(k)).slice(0, 3);
      up.hidden = !pieces || !pick.length;
      upRow.innerHTML = "";
      pick.forEach((k) => {
        const a = ANIMALS[k], c = a.colors[firstColor(k)];
        const b = document.createElement("button"); b.type = "button"; b.className = "dr-upc";
        b.innerHTML = '<span class="photo"><img alt="" width="120" height="120" loading="lazy"></span><b></b><span class="num"></span><i aria-hidden="true">+</i>';
        $("img", b).src = IMG + c.img; $("b", b).textContent = a.nick; $("span.num", b).textContent = euro(sale(a.price));
        b.setAttribute("aria-label", a.nick + " dazulegen");
        b.addEventListener("click", () => quickAdd(k, b));
        upRow.appendChild(b);
      });
    }
    $("[data-empty]").hidden = rows().length > 0;
    drawer.classList.toggle("is-empty", rows().length === 0);
    // Zähler blendet weich ein und aus, statt hart zu springen
    if (badge) { badge.classList.toggle("off", pieces === 0); if (pieces) badge.textContent = pieces; }
  };
  // Ein Tier aus den Vorschlägen direkt dazulegen
  const quickAdd = (k, btn) => {
    hearts(btn);
    if (SHOP) {
      const v = findVariant(k, firstColor(k));
      if (!v) { toast("Diese Auswahl ist gerade nicht verfügbar."); return; }
      api("/cart/add.js", { items: [{ id: v.id, quantity: 1 }] }).then(loadCart).catch(() => toast("Das hat nicht geklappt. Bitte noch einmal versuchen."));
      return;
    }
    const hit = local.find((x) => x.key === k && x.color === firstColor(k));
    hit ? (hit.n += 1) : local.push({ key: k, color: firstColor(k), qty: 1, n: 1 });
    renderCart();
  };
  // Kleine Herzen springen aus dem Knopf
  const hearts = (el) => {
    if (reduce || !el.animate) return;
    const r = el.getBoundingClientRect();
    for (let i = 0; i < 9; i++) {
      const h = document.createElement("span"); h.className = "pop-heart"; h.textContent = "♥";
      h.style.left = r.left + r.width / 2 + "px"; h.style.top = r.top + r.height / 2 + "px";
      document.body.appendChild(h);
      const ang = (Math.PI * 2 * i) / 9 + Math.random() * .4, dist = 50 + Math.random() * 40;
      h.animate([{ transform: "translate(-50%,-50%) scale(.4)", opacity: 1 }, { transform: "translate(calc(-50% + " + Math.cos(ang) * dist + "px), calc(-50% + " + Math.sin(ang) * dist + "px)) scale(1)", opacity: 0 }], { duration: 700 + Math.random() * 200, easing: "cubic-bezier(.2,0,0,1)" }).finished.then(() => h.remove());
    }
  };
  // Das Tier fliegt sichtbar in den Warenkorb, danach öffnet er sich
  const flyToCart = (from) => {
    const target = $(".cart-btn");
    if (reduce || !from || !target || !from.animate) return Promise.resolve();
    const src = from.getBoundingClientRect(), dst = target.getBoundingClientRect();
    const ghost = document.createElement("img");
    ghost.src = IMG + ANIMALS[state.animal].colors[state.color].img; ghost.alt = ""; ghost.className = "fly";
    const size = Math.min(140, src.width || 140);
    Object.assign(ghost.style, { width: size + "px", left: (src.left + src.width / 2 - size / 2) + "px", top: (src.top + src.height / 2 - size / 2) + "px" });
    document.body.appendChild(ghost);
    const dx = dst.left + dst.width / 2 - (src.left + src.width / 2), dy = dst.top + dst.height / 2 - (src.top + src.height / 2);
    const anim = ghost.animate([
      { transform: "translate(0,0) scale(1)", opacity: 1 },
      { transform: "translate(" + dx * 0.5 + "px," + (dy * 0.5 - 70) + "px) scale(.55)", opacity: 1, offset: .55 },
      { transform: "translate(" + dx + "px," + dy + "px) scale(.12)", opacity: .3 }
    ], { duration: 700, easing: "cubic-bezier(.5,0,.3,1)" });
    return anim.finished.then(() => { ghost.remove(); target.classList.remove("got"); void target.offsetWidth; target.classList.add("got"); });
  };
  const addToCart = (e) => {
    const btn = e && e.currentTarget;
    const done = () => {
      if (btn) { btn.classList.add("added"); setTimeout(() => btn.classList.remove("added"), 1600); hearts(btn); }
      const img = currentImg(), r = img && img.getBoundingClientRect();
      flyToCart(r && r.bottom > 60 && r.top < innerHeight ? img : btn).then(() => setTimeout(openCart, 120));
    };
    if (SHOP) {
      const v = findVariant(state.animal, state.color), v2 = state.qty === 2 ? findVariant(state.second.animal, state.second.color) : null;
      if (!v || (state.qty === 2 && !v2)) { toast("Diese Auswahl ist gerade nicht verfügbar."); return; }
      const items = v2 && v2.id === v.id ? [{ id: v.id, quantity: 2 }] : [{ id: v.id, quantity: 1 }].concat(v2 ? [{ id: v2.id, quantity: 1 }] : []);
      api("/cart/add.js", { items }).then(loadCart).then(done).catch(() => toast("Das hat nicht geklappt. Bitte noch einmal versuchen."));
      return;
    }
    const put = (k, col) => { const hit = local.find((x) => x.key === k && x.color === col); hit ? (hit.n += 1) : local.push({ key: k, color: col, qty: 1, n: 1 }); };
    put(state.animal, state.color);
    if (state.qty === 2) put(state.second.animal, state.second.color);
    renderCart(); done();
  };
  if (hero) $$("[data-buy]").forEach((b) => b.addEventListener("click", addToCart));
  if (drawer) {
    $$("[data-open-cart]").forEach((b) => b.addEventListener("click", openCart));
    $$("[data-close-cart]").forEach((b) => b.addEventListener("click", closeCart));
    scrim.addEventListener("click", closeCart);
    addEventListener("keydown", (e) => { if (e.key === "Escape" && drawer.classList.contains("on") && !$("dialog[open]")) closeCart(); });
    $("[data-checkout]").addEventListener("click", () => {
      if (!rows().length) toast("Leg zuerst ein Tier in den Warenkorb.");
      else if (SHOP) location.href = "/checkout";
      else toast("In der Vorschau gibt es keine Kasse. Im Shop geht es hier zu Shopify.");
    });
  }

  // ---------- 2er-Set: Rechnung mit echten Preisen, Knopf wählt zwei Tiere ----------
  const bundle = $("#zu-zweit");
  if (bundle && SET_OFF) {
    const base = Math.min(...KEYS.map((k) => ANIMALS[k].price));
    const one = sale(base) + shipFor(sale(base)), twoRaw = base * 2, two = twoRaw - offFor(twoRaw, 2) + shipFor(twoRaw - offFor(twoRaw, 2));
    setText("[data-b1-line]", euro(sale(base)) + " + " + euro(shipFor(sale(base))) + " Versand");
    setText("[data-b1]", euro(one));
    setText("[data-b2-line]", euro(twoRaw) + " − " + SET_OFF + " € · Versand frei");
    setText("[data-b2]", euro(two));
    setText("[data-b-second]", euro(two - one));
    const go = $("[data-bundle-go]");
    if (go) go.addEventListener("click", () => {
      if (!hero) { location.href = "/#kaufen"; return; }
      if (state.qty !== 2) { suggestSecond(); state.qty = 2; render(); }
      toast("2er-Set gewählt: Such dir dein zweites Tier aus");
      (secBox || hero).scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "center" });
    });
  }

  // ---------- Ankündigung oben: Hinweise wechseln sich sanft ab ----------
  const ann = $$("[data-announce] .an-msg");
  if (ann.length > 1 && !reduce) {
    let ai = 0;
    setInterval(() => { ann[ai].classList.remove("is-on"); ai = (ai + 1) % ann.length; ann[ai].classList.add("is-on"); }, 3800);
  }

  // ---------- Kaufleiste unten (Handy und PC): erscheint, sobald der Kaufen-Knopf oben aus dem Bild ist ----------
  const bar = $("[data-bar]"), heroBtn = hero && $(".cta[data-buy]", hero);
  if (bar && heroBtn && "IntersectionObserver" in window) {
    const setBar = (on) => {
      bar.classList.toggle("on", on); bar.setAttribute("aria-hidden", !on); $$("button", bar).forEach((b) => (b.tabIndex = on ? 0 : -1));
    };
    new IntersectionObserver(([e]) => setBar(!e.isIntersecting && e.boundingClientRect.top < 0)).observe(heroBtn);
  }

  // ---------- So rennen sie: Panda wackelt, solange er zu sehen ist; Antippen wackelt sofort ----------
  const demo = $("[data-demo]");
  if (demo && !reduce) {
    if ("IntersectionObserver" in window) new IntersectionObserver(([e]) => demo.classList.toggle("play", e.isIntersecting), { threshold: .4 }).observe(demo);
    demo.addEventListener("click", () => { demo.classList.remove("play"); void demo.offsetWidth; demo.classList.add("play"); });
  }

  // ---------- Darum wirst du ihn lieben: Punkte im Foto, wechseln von selbst, bis jemand tippt ----------
  const hot = $("[data-hot]");
  if (hot) {
    const SPOTS = [
      ["Ein dickes Pony", "Lang, weich und zum Wuscheln."],
      ["Weiche Hörnchen", "Ganz aus Plüsch. Nichts Hartes, nichts Spitzes."],
      ["Kuschelfell", "Dicht, weich und groß genug zum Drücken."],
      ["Lauf-Beinchen", "Locker angenäht, beim Schütteln rennen sie los."]
    ];
    const box = $("[data-hot-text]"), num = $("[data-hot-n]"), dots = $$("[data-hs]", hot);
    let cur = 0, timer = null;
    const show = (i) => {
      cur = i;
      dots.forEach((d) => d.setAttribute("aria-pressed", +d.dataset.hs === i));
      num.textContent = i + 1 + " / " + SPOTS.length;
      box.innerHTML = "<h3></h3><p></p>"; $("h3", box).textContent = SPOTS[i][0]; $("p", box).textContent = SPOTS[i][1];
      box.classList.remove("swap"); void box.offsetWidth; box.classList.add("swap");
    };
    // Nahaufnahme: ins Foto an die Stelle des Punktes zoomen (oder eigenes Makro-Foto, falls data-macro gesetzt ist)
    const hotImg = $(".photo img", hot), baseSrc = hotImg.getAttribute("src"), reset = $("[data-hot-reset]");
    const zoomTo = (d) => {
      const macro = d && d.dataset.macro;
      hotImg.src = macro || baseSrc;
      hot.classList.toggle("zoomed", !!d && !macro);
      hot.classList.toggle("macro", !!macro);
      if (d && !macro) hotImg.style.transformOrigin = d.style.getPropertyValue("--x") + " " + d.style.getPropertyValue("--y");
      if (reset) reset.hidden = !d;
    };
    dots.forEach((d) => d.addEventListener("click", () => { clearInterval(timer); timer = null; show(+d.dataset.hs); zoomTo(d); }));
    if (reset) reset.addEventListener("click", () => zoomTo(null));
    if (!reduce && "IntersectionObserver" in window) {
      new IntersectionObserver(([e]) => {
        if (e.isIntersecting && timer === null && !hot.dataset.touched) timer = setInterval(() => show((cur + 1) % SPOTS.length), 3600);
        else if (!e.isIntersecting && timer) { clearInterval(timer); timer = null; }
      }, { threshold: .5 }).observe(hot);
      dots.forEach((d) => d.addEventListener("click", () => (hot.dataset.touched = "1")));
    }
  }

  // ---------- Geschenk-Finder ----------
  const finder = $("[data-finder]");
  if (finder) {
    const TIPS = [
      { k: "roter-panda", c: "rotbraun", q: 1, why: "55\u00a0cm zum Drücken. Und ihr lacht beide, wenn sie losrennt." },
      { k: "hase", c: "creme", q: 1, why: "Weich, kuschelig und zum Liebhaben." },
      { k: "kuh", c: "rosa", q: 2, s: { animal: "kuh", color: "weiss" }, why: "Klara in Rosa für sie, in Weiß für dich." + (SET_OFF ? " Im Set " + SET_OFF + " € günstiger." : "") },
      { k: "panda", c: "schwarz", q: 1, why: "Weil du auch mal dran bist." }
    ];
    const pic = $(".f-pic", finder), img = $("[data-f-img]"), body = $("[data-f-body]");
    let tip = TIPS[0];
    const showTip = (i) => {
      tip = TIPS[i];
      const a = ANIMALS[tip.k], c = a.colors[tip.c];
      $$("[data-for]").forEach((t) => t.setAttribute("aria-selected", +t.dataset.for === i));
      const swap = () => { img.src = IMG + c.img; img.alt = c.alt; };
      if (reduce) swap(); else { pic.classList.add("swap"); setTimeout(() => { swap(); pic.classList.remove("swap"); }, 200); }
      $("[data-f-name]").textContent = tip.q === 2 ? "2× " + a.nick + " im Set" : a.nick + ", " + a.name;
      $("[data-f-why]").textContent = tip.why;
      $("[data-f-price]").textContent = euro(tip.q === 2 ? a.price + ANIMALS[tip.s.animal].price - offFor(a.price + ANIMALS[tip.s.animal].price, 2) : sale(a.price));
      body.classList.remove("swap"); void body.offsetWidth; body.classList.add("swap");
    };
    $$("[data-for]").forEach((t) => t.addEventListener("click", () => showTip(+t.dataset.for)));
    $("[data-f-pick]").addEventListener("click", () => {
      pickAnimal(tip.k); state.color = tip.c; state.qty = tip.q; if (tip.s) state.second = { ...tip.s }; render();
      toast(tip.q === 2 ? "2er-Set mit 2× " + ANIMALS[tip.k].nick + " ist ausgewählt" : ANIMALS[tip.k].nick + " ist ausgewählt");
      hero.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
    });
  }


  // ---------- Mini-Spiel: Wettrennen der vier Tiere ----------
  const race = $("[data-race]");
  if (race) {
    const goBtn = $("[data-race-go]"), msg = $("[data-race-msg]"), pickBtn = $("[data-race-pick]");
    let bet = null, running = false, winner = null;
    const runners = $$("[data-bet]", race);
    runners.forEach((b) => b.addEventListener("click", () => {
      if (running) return;
      bet = b.dataset.bet;
      runners.forEach((x) => x.setAttribute("aria-pressed", x === b));
      msg.textContent = "Dein Tipp: " + ANIMALS[bet].nick + ". Bereit?";
    }));
    const reset = () => runners.forEach((b) => { b.style.transform = ""; b.classList.remove("running", "won"); b.parentElement.classList.remove("win"); });
    goBtn.addEventListener("click", () => {
      if (running) return;
      if (!bet) { msg.textContent = "Tipp zuerst auf deinen Liebling."; runners.forEach((b) => b.classList.add("nudge")); setTimeout(() => runners.forEach((b) => b.classList.remove("nudge")), 600); return; }
      reset(); running = true; goBtn.disabled = true; pickBtn.hidden = true; msg.textContent = "Und los!";
      const times = runners.map(() => 2200 + Math.random() * 1400);
      const best = times.indexOf(Math.min(...times));
      runners.forEach((b, i) => {
        const dist = b.parentElement.clientWidth - b.offsetWidth - 8;
        b.classList.add("running");
        if (reduce || !b.animate) { b.style.transform = "translateX(" + dist + "px)"; return; }
        // kleine Tempowechsel, damit es spannend bleibt
        const mid = .35 + Math.random() * .3;
        b.animate([{ transform: "translateX(0)" }, { transform: "translateX(" + dist * mid + "px)", offset: .5 }, { transform: "translateX(" + dist + "px)" }], { duration: times[i], easing: "linear", fill: "forwards" });
      });
      setTimeout(() => {
        running = false; goBtn.disabled = false; goBtn.textContent = "Nochmal rennen";
        runners.forEach((b) => b.classList.remove("running"));
        const w = runners[best]; winner = w.dataset.bet;
        w.classList.add("won"); w.parentElement.classList.add("win"); hearts(w);
        msg.textContent = ANIMALS[winner].nick + " gewinnt!" + (winner === bet ? " Dein Tipp war richtig." : " Nächstes Mal klappt's.");
        pickBtn.hidden = !hero; pickBtn.textContent = ANIMALS[winner].nick + " aussuchen";
      }, reduce ? 300 : Math.max(...times) + 100);
    });
    pickBtn.addEventListener("click", () => {
      if (!winner || !hero) return;
      pickAnimal(winner); toast(ANIMALS[winner].nick + " ist ausgewählt");
      hero.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
    });
  }
  // ---------- Lieferung: echte Daten statt „5–10 Werktage“ ----------
  const ship = $("[data-ship]");
  if (ship) {
    const fmt = (d) => d.toLocaleDateString(LOC, { weekday: "short", day: "numeric", month: "long" });
    const addWorkdays = (d, n) => { const x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() % 6) n--; } return x; };
    const now = new Date();
    $("[data-d0]").textContent = fmt(now);
    $("[data-d2]").textContent = "voraussichtlich zwischen " + fmt(addWorkdays(now, 5)) + " und " + fmt(addWorkdays(now, 10));
    // Weihnachten: Bestellschluss 5.12. (Schätzung, siehe FAQ und Versandinfos)
    const y = now.getFullYear(), cut = new Date(y, 11, 5, 23, 59), xmas = $("[data-xmas]");
    const days = now > cut ? -1 : Math.round((new Date(y, 11, 5) - new Date(y, now.getMonth(), now.getDate())) / 864e5);
    if (now.getMonth() >= 9 && days >= 0) {
      xmas.hidden = false;
      xmas.innerHTML = days === 0 ? "<b>Heute</b> ist der letzte Tag, damit es voraussichtlich bis Heiligabend ankommt." : "Noch <b class=\"num\">" + days + " Tage</b> bestellen, damit es voraussichtlich bis Heiligabend ankommt.";
    }
  }

  // ---------- Lauf-Video: kleines Fenster öffnet die Großansicht; Videos laufen nur, wenn sie zu sehen sind ----------
  const clip = $("[data-clip]");
  if (clip) {
    const small = $("video", clip);
    const dlg = document.createElement("dialog");
    dlg.className = "vid-modal"; dlg.setAttribute("aria-label", "Video: so läuft das Tier");
    dlg.innerHTML = '<video muted loop playsinline controls></video><button type="button" class="vx" aria-label="Video schließen">×</button>';
    document.body.appendChild(dlg);
    const big = $("video", dlg);
    clip.addEventListener("click", () => { big.src = small.currentSrc || small.src; big.poster = small.poster; dlg.showModal(); big.play().catch(() => {}); });
    const shut = () => { big.pause(); dlg.close(); };
    $(".vx", dlg).addEventListener("click", shut);
    dlg.addEventListener("click", (e) => { if (e.target === dlg) shut(); });
    dlg.addEventListener("close", () => big.pause());
  }
  const playWhenSeen = (v, auto) => {
    if (!v || !("IntersectionObserver" in window)) return;
    new IntersectionObserver(([e]) => {
      if (e.isIntersecting && (auto || !reduce)) { if (v.preload === "none") v.preload = "auto"; v.play().catch(() => {}); }
      else v.pause();
    }, { threshold: .35 }).observe(v);
  };
  if (clip) playWhenSeen($("video", clip), true);
  playWhenSeen($("[data-howvid]"), true);

  // ============================================================
  // BEWERTUNGEN: Einträge aus Shopify (Metaobjekt „Bewertung“). Durchschnitt, Anzahl und Verteilung werden daraus berechnet.
  // Die Vorlage-Einträge aus ff-demo.js erscheinen nur, solange es keine echten gibt und das Theme nicht live ist.
  // ============================================================
  const isMain = !!(window.Shopify && window.Shopify.theme && window.Shopify.theme.role === "main");
  // Demo-Bewertungen live nur für die Inhaberin: ?demo=1 an, ?demo=0 aus (nur in diesem Browser)
  let demoOn = false;
  try {
    const q = new URLSearchParams(location.search).get("demo");
    if (q === "1") localStorage.setItem("ff-demo", "1");
    if (q === "0") localStorage.removeItem("ff-demo");
    demoOn = localStorage.getItem("ff-demo") === "1";
  } catch (e) {}
  const isLive = false; // Demo-Theme: Demo-Bewertungen immer an (nur hinter Passwort benutzen)
  const RAW = (window.FF_REVIEWS && window.FF_REVIEWS.length) ? window.FF_REVIEWS : (!isLive && window.FF_DEMO) ? window.FF_DEMO.concat(window.FF_DEMO_STARS || []) : [];
  // Alle Bewertungen zählen für Durchschnitt und Verteilung, auch reine Sterne ohne Text
  const ALL = RAW.filter((r) => r && +r.sterne > 0);
  const REV = RAW.filter((r) => r && r.text).map((r) => Object.assign({}, r, { foto: null })).sort((a, b) => (b.datum || "").localeCompare(a.datum || ""));
  const photoSrc = (f) => !f ? null : /^(https?:)?\/\//.test(f) || f.startsWith("/") ? f : IMG + f;
  const NICK = { Hochlandkuh: "Klara", Panda: "Paul", "Roter Fuchs": "Ruby", "Roter Panda": "Ruby", Hase: "Hanni" };
  const comma = (n) => n.toFixed(1).replace(".", ",");
  const revDate = (s) => { const d = new Date(s + "T12:00:00"); return isNaN(d) ? "" : d.toLocaleDateString(LOC, { day: "numeric", month: "long", year: "numeric" }); };
  const avgOf = (rs) => rs.length ? rs.reduce((s, r) => s + (+r.sterne || 0), 0) / rs.length : 0;
  const nWord = (n) => n + (n === 1 ? " Bewertung" : " Bewertungen");
  const nRev = ALL.length, avg = avgOf(ALL);
  $$("[data-rv-inline]").forEach((el) => {
    if (!nRev) return;
    el.hidden = false;
    $("[data-rv-stars]", el).style.setProperty("--v", avg);
    $("[data-rv-inline-text]", el).textContent = comma(avg) + " von 5 · " + nWord(nRev);
  });
  // Vertrauens-Band: Bewertung aus den Einträgen, Kundenzahl aus dem Shop-Metafeld (Vorlage nur, solange das Theme nicht live ist)
  const proofR = $("[data-proof-rating]");
  if (proofR && nRev) {
    proofR.hidden = false;
    $("[data-proof-avg]").textContent = comma(avg) + " ★";
    $("[data-proof-stars]").style.setProperty("--v", avg);
    $("[data-proof-count]").textContent = nWord(nRev);
  }
  const proofK = $("[data-proof-kunden]");
  if (proofK) {
    const n = parseInt(proofK.dataset.n, 10) || (!isLive && window.FF_DEMO_KUNDEN) || 0;
    if (n) {
      proofK.hidden = false;
      const el = $("[data-count-to]", proofK), fmt = (v) => Math.round(v).toLocaleString(LOC) + "+";
      el.textContent = fmt(n);
      // Zahl zählt hoch, wenn das Band ins Bild kommt
      if (!reduce && "IntersectionObserver" in window) {
        el.textContent = fmt(0);
        new IntersectionObserver(([e], o) => {
          if (!e.isIntersecting) return; o.disconnect();
          const t0 = performance.now();
          const step = (t) => { const k = Math.min(1, (t - t0) / 1200); el.textContent = fmt(n * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(step); };
          requestAnimationFrame(step);
        }, { threshold: .5 }).observe(el);
      }
    }
  }
  const heroProof = $("[data-hero-proof]");
  if (heroProof && nRev) {
    const k = proofK ? parseInt(proofK.dataset.n, 10) || (!isLive && window.FF_DEMO_KUNDEN) || 0 : 0;
    heroProof.hidden = false;
    $(".stars", heroProof).style.setProperty("--v", avg);
    $("[data-hero-proof-t]", heroProof).textContent = comma(avg) + (k ? " · " + k.toLocaleString(LOC) + "+ glückliche Kunden" : " · " + nWord(nRev));
  }
  // Sterne pro Tier auf Karten und im Katalog
  $$("[data-rv-for]").forEach((el) => {
    const rs = ALL.filter((r) => r.tier === el.dataset.rvFor);
    if (!rs.length) return;
    el.hidden = false;
    el.innerHTML = '<span class="stars" style="--v:' + avgOf(rs) + '"></span><span></span>';
    el.lastChild.textContent = comma(avgOf(rs)) + " (" + rs.length + ")";
    el.setAttribute("aria-label", comma(avgOf(rs)) + " von 5 Sternen, " + nWord(rs.length));
  });
  $$("[data-reviews]").forEach((sec) => {
    const page = sec.dataset.reviews === "page", step = page ? 12 : 6;
    const list = $("[data-rv-list]", sec), more = $("[data-rv-more]", sec), empty = $("[data-rv-empty]", sec), filter = $("[data-rv-filter]", sec);
    const tools = $("[data-rv-tools]", sec), sortSel = $("[data-rv-sort]", sec), photoOnly = $("[data-rv-photos]", sec), strip = $("[data-rv-strip]", sec);
    if (!nRev) { empty.hidden = false; filter.hidden = true; if (tools) tools.hidden = true; return; }
    $("[data-rv-avg]", sec).textContent = comma(avg);
    $("[data-rv-stars]", sec).style.setProperty("--v", avg);
    $("[data-rv-count]", sec).textContent = "aus " + nWord(nRev);
    const good = $("[data-rv-good]", sec);
    if (good) { good.hidden = false; $("b", good).textContent = Math.round(ALL.filter((r) => +r.sterne >= 4).length / nRev * 100) + " %"; }
    const bars = $("[data-rv-bars]", sec);
    [5, 4, 3, 2, 1].forEach((s) => {
      const c = ALL.filter((r) => +r.sterne === s).length;
      const li = document.createElement("li");
      li.innerHTML = "<span></span><i><b></b></i><span class=\"num\"></span>";
      li.firstChild.textContent = s + " ★"; li.lastChild.textContent = c;
      $("b", li).style.setProperty("--w", (c / nRev) * 100 + "%");
      bars.appendChild(li);
    });
    // Balken wachsen, wenn sie ins Bild kommen
    if ("IntersectionObserver" in window && !reduce) {
      bars.classList.add("pre");
      new IntersectionObserver(([e], o) => { if (e.isIntersecting) { bars.classList.remove("pre"); o.disconnect(); } }, { threshold: .4 }).observe(bars);
    }
    // Anzahl pro Tier in den Filterknöpfen
    $$("[data-rv-tier]", sec).forEach((b) => {
      const c = b.dataset.rvTier ? REV.filter((r) => r.tier === b.dataset.rvTier).length : nRev;
      const s = document.createElement("small"); s.className = "num"; s.textContent = c; b.appendChild(s);
    });
    let tier = "", shown = 0;
    const card = (r, i) => {
      const a = document.createElement("article"); a.className = "rv-card"; a.style.setProperty("--d", i % step);
      a.innerHTML = '<p class="rv-top"><span class="stars" style="--v:' + (+r.sterne || 0) + '" aria-label="' + (+r.sterne || 0) + ' von 5 Sternen"></span><time></time></p><h3></h3><p class="rv-text"></p>' +
        (r.foto ? '<button type="button" class="rv-photo" aria-label="Foto groß ansehen"><img alt="" loading="lazy" width="240" height="240"></button>' : "") +
        '<p class="rv-meta"><span class="rv-av" aria-hidden="true"></span><b></b><span class="rv-tag"></span>' + (r.kauf ? '<span class="rv-ok">Verifizierter Kauf</span>' : "") + "</p>" +
        (r.antwort ? '<div class="rv-reply"><p class="rv-reply-h">Antwort von FlauschFreude</p><p class="rv-reply-t"></p></div>' : "");
      $("time", a).textContent = revDate(r.datum); $("time", a).dateTime = r.datum || "";
      $("h3", a).textContent = r.titel || "";
      $(".rv-text", a).textContent = r.text;
      if (r.foto) { $(".rv-photo img", a).src = r.foto; $(".rv-photo", a).addEventListener("click", () => openPhoto(r)); }
      $(".rv-av", a).textContent = (r.name || "?").trim().charAt(0).toUpperCase();
      $(".rv-meta b", a).textContent = r.name + (r.ort ? ", " + r.ort : "");
      $(".rv-tag", a).textContent = (NICK[r.tier] ? NICK[r.tier] + " · " : "") + (r.farbe || r.tier || "");
      if (r.antwort) $(".rv-reply-t", a).textContent = r.antwort;
      return a;
    };
    const SORTS = {
      neu: (a, b) => (b.datum || "").localeCompare(a.datum || ""),
      gut: (a, b) => (+b.sterne - +a.sterne) || (b.datum || "").localeCompare(a.datum || ""),
      kritisch: (a, b) => (+a.sterne - +b.sterne) || (b.datum || "").localeCompare(a.datum || ""),
    };
    const pool = () => REV.filter((r) => (!tier || r.tier === tier) && (!photoOnly || !photoOnly.checked || r.foto)).sort(SORTS[sortSel ? sortSel.value : "neu"] || SORTS.neu);
    const draw = (reset) => {
      const p = pool();
      if (reset) { list.innerHTML = ""; shown = 0; }
      p.slice(shown, shown + step).forEach((r, i) => list.appendChild(card(r, i)));
      shown = Math.min(p.length, shown + step);
      more.hidden = shown >= p.length;
      more.textContent = "Mehr Bewertungen zeigen (" + (p.length - shown) + ")";
      if (!p.length) list.innerHTML = '<p class="rv-none">Dazu gibt es noch keine Bewertung.</p>';
    };
    $$("[data-rv-tier]", sec).forEach((b) => b.addEventListener("click", () => {
      tier = b.dataset.rvTier;
      $$("[data-rv-tier]", sec).forEach((x) => x.setAttribute("aria-selected", x === b));
      draw(true);
    }));
    if (sortSel) sortSel.addEventListener("change", () => draw(true));
    if (photoOnly) photoOnly.addEventListener("change", () => draw(true));
    more.addEventListener("click", () => draw(false));
    // Kundenfotos als Leiste über den Bewertungen
    const withPhoto = REV.filter((r) => r.foto);
    if (strip && withPhoto.length) {
      strip.hidden = false;
      const row = $("[data-rv-strip-row]", strip);
      withPhoto.slice(0, page ? 12 : 8).forEach((r) => {
        const b = document.createElement("button"); b.type = "button"; b.className = "rv-shot";
        b.innerHTML = '<img alt="" loading="lazy" width="160" height="160"><span class="stars" style="--v:' + (+r.sterne || 0) + '"></span>';
        $("img", b).src = r.foto; b.setAttribute("aria-label", "Foto von " + r.name + " ansehen");
        b.addEventListener("click", () => openPhoto(r));
        row.appendChild(b);
      });
    }
    draw(true);
  });
  // Weihnachts-Countdown bis zum Bestellschluss (5.12., wie in den Versandinfos); zeigt sich ab 15.10. und verschwindet danach von selbst
  const xm = $("[data-xcount]");
  if (xm && $("[data-xcount-t]", xm)) {
    const now = new Date(), y = now.getFullYear();
    const end = new Date(y, 11, 5, 23, 59, 59), start = new Date(y, 9, 15);
    if (now >= start && now <= end) {
      const today = new Date(y, now.getMonth(), now.getDate());
      const days = Math.round((new Date(y, 11, 5) - today) / 864e5);
      $("[data-xcount-t]", xm).innerHTML = days === 0 ? "<b>Heute</b> ist Bestellschluss für Weihnachten!" : days === 1 ? "Nur noch <b>1 Tag</b> bis zum Bestellschluss für Weihnachten" : "Noch <b>" + days + " Tage</b> bis zum Bestellschluss für Weihnachten (5.12.)";
      xm.hidden = false;
    }
  }
  // Kundenfotos „Bei euch zuhause“: echte Fotos aus den Bewertungen; ohne echte Fotos nur in der Vorschau die Beispiel-Fotos
  const snapSec = $("[data-snaps]");
  if (snapSec) {
    const real = (window.FF_REVIEWS || []).filter((r) => r && r.foto && r.text);
    const src = real.length ? real : (!isLive && window.FF_DEMO_SNAPS) || [];
    const snaps = src.slice(0, 6).map((r) => Object.assign({}, r, { foto: photoSrc(r.foto) }));
    const row = $("[data-snap-row]", snapSec);
    snaps.forEach((r, i) => {
      const card = document.createElement("figure");
      card.className = "snap reveal"; card.style.setProperty("--d", i); card.style.setProperty("--tilt", [-2.5, 1.8, -1.2, 2.2, -1.8, 1.2][i % 6] + "deg");
      card.innerHTML = '<button type="button" class="snap-pic"><img alt="" loading="lazy" decoding="async" width="560" height="700"><span class="snap-tape" aria-hidden="true"></span><span class="snap-more" aria-hidden="true"><b>+</b>Bewertung lesen</span></button>' +
        '<figcaption><span class="stars"></span><b class="snap-t"></b><p class="snap-q"></p><span class="snap-who"></span></figcaption>';
      const img = $("img", card);
      img.src = r.foto; img.alt = "Kundenfoto: " + (NICK[r.tier] || r.tier || "Plüschtier") + (r.farbe ? " in " + r.farbe : "");
      img.addEventListener("error", () => { card.remove(); if (!$(".snap", row)) snapSec.hidden = true; });
      $(".stars", card).style.setProperty("--v", +r.sterne || 0);
      $(".stars", card).setAttribute("aria-label", (+r.sterne || 0) + " von 5 Sternen");
      $(".snap-t", card).textContent = r.titel || "";
      $(".snap-q", card).textContent = r.text;
      $(".snap-who", card).textContent = r.name + (r.ort ? ", " + r.ort : "") + " · " + (NICK[r.tier] || r.tier || "") + (r.farbe ? " in " + r.farbe : "");
      $(".snap-pic", card).setAttribute("aria-label", "Foto von " + r.name + " groß ansehen");
      $(".snap-pic", card).addEventListener("click", () => openPhoto(r));
      row.appendChild(card);
    });
    snapSec.hidden = !snaps.length;
  }
  // Kundenfoto groß, mit der zugehörigen Bewertung
  function openPhoto(r) {
    let d = $("[data-rv-dialog]");
    if (!d) {
      d = document.createElement("dialog"); d.className = "rv-dialog"; d.setAttribute("data-rv-dialog", "");
      d.innerHTML = '<button type="button" class="rv-dx" aria-label="Schließen">×</button><img alt=""><div class="rv-dbody"><span class="stars"></span><h3></h3><p class="rv-text"></p><p class="rv-meta"></p></div>';
      document.body.appendChild(d);
      $(".rv-dx", d).addEventListener("click", () => d.close());
      d.addEventListener("click", (e) => { if (e.target === d) d.close(); });
    }
    $("img", d).src = r.foto; $("img", d).alt = "Kundenfoto: " + (NICK[r.tier] || r.tier || "");
    $(".stars", d).style.setProperty("--v", +r.sterne || 0);
    $("h3", d).textContent = r.titel || ""; $(".rv-text", d).textContent = r.text;
    $(".rv-meta", d).textContent = r.name + (r.ort ? ", " + r.ort : "") + " · " + (NICK[r.tier] ? NICK[r.tier] + " · " : "") + (r.farbe || "");
    d.showModal ? d.showModal() : d.setAttribute("open", "");
  }

  // Produktseite /products/<handle> oder ?tier=kuh: dieses Tier vorwählen
  const m = location.pathname.match(/\/products\/([^/?#]+)/), q = new URLSearchParams(location.search).get("tier");
  const startKey = (m && keyOfHandle(m[1])) || (ANIMALS[q] ? q : null);
  if (hero) {
    buildSwatches();
    if (startKey) { pickAnimal(startKey); goToSlide(startKey, false); } else render();
  }
  SHOP ? loadCart() : renderCart();
})();
